import React from "react";
import { StyledPhone, IphoneContent, Wrapper } from "./styled";
import iPhonePng from "../../assets/images/iPhoneX.png";

export default ({ url }: { url: string }) => {
  return (
    <Wrapper>
      <StyledPhone bg={iPhonePng} />
      {url && (
        <IphoneContent>
          <img className="img-responsive" src={url} />{" "}
        </IphoneContent>
      )}
      {/* <IphoneContent>{image && <GatsbyImage image={image} alt="iPhone screenshot" />}</IphoneContent> */}
    </Wrapper>
  );
};
